module.exports = __webpack_public_path__ + "static/img/t3_t.6a8cee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/t3_t.jpg
// module id = zILD
// module chunks = 0